import { Row, View } from '@woodmac-hycb/layout';
import './CustomAlertManager.css'
import { Button } from '@woodmac-hycb/button';
import { TextView } from "@woodmac-hycb/typography";
import { useAuth0 } from '@auth0/auth0-react';

function Header() {

  const {logout} = useAuth0();

  return (
    <Row gap={64} className='header header-box'>
        <TextView fontSize={50} as="h1">Custom Alert Manager</TextView>
        <View alignItems='center'>
          <Button onClick={logout}>Logout</Button>
        </View>
    </Row>
  );
} export default Header;